
let back = ['Beszerzés','Alapanyag elhozatal','Visszáru','Alvállalkozótól vissza'];

export function backwards(d){
  if(!d || !d.type) return false;
  if(d.back) return true;
  return back.includes(d.type);
}